var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496.941 496.941",
    style: {
      enableBackground: "new 0 0 496.941 496.941"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.647,279.341h232.659c4.518,0,7.529-3.012,7.529-7.529v-75.294c0-4.518-3.765-7.529-7.529-7.529H37.647     c-4.518,0-7.529,3.012-7.529,7.529v75.294C30.118,276.329,33.129,279.341,37.647,279.341z M45.176,204.047h217.6v60.235h-217.6     V204.047z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.788,292.894H42.165c-4.518,0-7.529,3.012-7.529,7.529v30.871c0,4.518,3.012,7.529,7.529,7.529h31.624     c4.518,0,7.529-3.012,7.529-7.529v-31.624C81.318,295.906,77.553,292.894,73.788,292.894z M66.259,323.765H49.694V307.2h16.565     V323.765z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.788,356.141H42.165c-4.518,0-7.529,3.012-7.529,7.529v31.624c0,4.518,3.012,7.529,7.529,7.529h31.624     c4.518,0,7.529-3.012,7.529-7.529v-31.624C81.318,359.153,77.553,356.141,73.788,356.141z M66.259,387.765H49.694V371.2h16.565     V387.765z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.788,419.388H42.165c-4.518,0-7.529,3.012-7.529,7.529v31.624c0,4.518,3.012,7.529,7.529,7.529h31.624     c4.518,0,7.529-3.012,7.529-7.529v-31.624C81.318,423.153,77.553,419.388,73.788,419.388z M66.259,451.012H49.694v-16.565h16.565     V451.012z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.788,292.894h-31.624c-4.518,0-7.529,3.012-7.529,7.529v30.871c0,4.518,3.012,7.529,7.529,7.529h31.624     c4.518,0,7.529-3.012,7.529-7.529v-31.624C145.318,295.906,141.553,292.894,137.788,292.894z M130.259,323.765h-16.565V307.2     h16.565V323.765z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.788,356.141h-31.624c-4.518,0-7.529,3.012-7.529,7.529v31.624c0,4.518,3.012,7.529,7.529,7.529h31.624     c4.518,0,7.529-3.012,7.529-7.529v-31.624C145.318,359.153,141.553,356.141,137.788,356.141z M130.259,387.765h-16.565V371.2     h16.565V387.765z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.788,419.388h-31.624c-4.518,0-7.529,3.012-7.529,7.529v31.624c0,4.518,3.012,7.529,7.529,7.529h31.624     c4.518,0,7.529-3.012,7.529-7.529v-31.624C145.318,423.153,141.553,419.388,137.788,419.388z M130.259,451.012h-16.565v-16.565     h16.565V451.012z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.788,292.894h-31.624c-4.518,0-7.529,3.012-7.529,7.529v30.871c0,4.518,3.012,7.529,7.529,7.529h31.624     c4.518,0,7.529-3.012,7.529-7.529v-31.624C209.318,295.906,205.553,292.894,201.788,292.894z M194.259,323.765h-16.565V307.2     h16.565V323.765z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.788,356.141h-31.624c-4.518,0-7.529,3.012-7.529,7.529v31.624c0,4.518,3.012,7.529,7.529,7.529h31.624     c4.518,0,7.529-3.012,7.529-7.529v-31.624C209.318,359.153,205.553,356.141,201.788,356.141z M194.259,387.765h-16.565V371.2     h16.565V387.765z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.788,419.388h-31.624c-4.518,0-7.529,3.012-7.529,7.529v31.624c0,4.518,3.012,7.529,7.529,7.529h31.624     c4.518,0,7.529-3.012,7.529-7.529v-31.624C209.318,423.153,205.553,419.388,201.788,419.388z M194.259,451.012h-16.565v-16.565     h16.565V451.012z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.035,292.894h-30.871c-4.518,0-7.529,3.012-7.529,7.529v30.871c0,4.518,3.012,7.529,7.529,7.529h30.871     c4.518,0,7.529-3.012,7.529-7.529v-31.624C272.565,295.906,269.553,292.894,265.035,292.894z M257.506,323.765h-15.812V307.2     h15.812V323.765z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.035,356.141h-30.871c-4.518,0-7.529,3.012-7.529,7.529v94.871c0,4.518,3.012,7.529,7.529,7.529h30.871     c4.518,0,7.529-3.012,7.529-7.529v-94.871C272.565,359.153,269.553,356.141,265.035,356.141z M257.506,451.012h-15.812V371.2     h15.812V451.012z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.682,131.012L360.659,2.259C359.153,0.753,356.894,0,355.388,0H96.376c-4.518,0-7.529,3.012-7.529,7.529v149.082     H7.529c-4.518,0-7.529,3.012-7.529,7.529v325.271c0,4.518,3.012,7.529,7.529,7.529s19.576,0,481.882,0     c4.518,0,7.529-3.012,7.529-7.529c0-31.624,0,68.518,0-353.129C496.941,134.776,496.188,132.518,494.682,131.012z      M362.918,24.847L470.588,128H362.918V24.847z M292.894,481.882H15.059V171.671h277.835V481.882z M481.882,481.882H307.953     V164.141c0-4.518-3.012-7.529-7.529-7.529H103.906V15.059h243.953v121.224c0,4.518,3.012,7.529,7.529,7.529h126.494     C481.882,402.071,481.882,478.118,481.882,481.882z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.906,47.435H144.565c-4.518,0-7.529,3.012-7.529,7.529s3.012,7.529,7.529,7.529h151.341     c4.518,0,7.529-3.012,7.529-7.529C303.435,50.447,300.424,47.435,295.906,47.435z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.906,91.859H144.565c-4.518,0-7.529,3.012-7.529,7.529s3.012,7.529,7.529,7.529h151.341     c4.518,0,7.529-3.012,7.529-7.529S300.424,91.859,295.906,91.859z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.765,240.188c0,39.906,32.376,73.035,72.282,73.035s72.282-32.376,72.282-73.035s-32.376-73.035-72.282-73.035     S323.765,199.529,323.765,240.188z M396.047,181.459c31.623,0,57.224,25.6,57.224,57.977c0,32.376-25.6,57.976-57.224,57.976     s-57.224-25.6-57.224-57.976S364.424,181.459,396.047,181.459z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.047,322.259c-39.906,0-72.282,32.376-72.282,73.035c0,40.659,32.376,73.035,72.282,73.035     s72.282-32.376,72.282-73.035C468.329,354.635,435.953,322.259,396.047,322.259z M396.047,452.518     c-31.624,0-57.224-25.6-57.224-57.977s25.6-57.976,57.224-57.976c31.623,0,57.224,25.6,57.224,57.976     S427.671,452.518,396.047,452.518z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.965,256l-7.529,9.035c7.529,6.776,16.565,10.541,26.353,12.047v7.529h6.776v-7.529c7.529,0,12.8-2.259,17.318-6.776     c4.518-3.765,6.776-9.035,6.776-15.059s-2.259-11.294-6.024-14.306c-3.765-3.765-9.788-6.776-18.071-8.282v-20.329     c5.271,0.753,10.541,3.012,15.059,6.023l6.776-9.788c-6.776-4.518-14.306-7.529-21.835-8.282v-5.271h-6.776v5.271     c-6.776,0-12.8,2.259-16.565,6.776c-4.518,3.765-6.776,9.035-6.776,15.059c0,6.024,1.506,10.541,5.271,14.306     c3.765,3.012,9.788,6.023,17.318,7.529v21.082C387.012,264.282,380.235,261.271,374.965,256z M399.812,245.459     c4.518,1.506,7.529,3.012,9.035,3.765c1.506,1.506,2.259,3.765,2.259,6.024c0,3.012-0.753,5.271-3.012,6.776     c-2.259,1.506-4.518,3.012-8.282,3.012V245.459z M385.506,226.635c-1.506-1.506-2.259-3.012-2.259-6.024     c0-2.259,0.753-4.518,3.012-6.023c1.506-1.506,4.518-2.259,7.529-3.012V230.4h0C390.023,228.894,387.012,228.141,385.506,226.635     z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.471,390.776c3.765,0,7.529-1.506,10.541-4.518c3.012-3.012,4.518-6.776,4.518-10.541     c0-4.518-1.506-7.529-3.765-10.541c-3.765-3.765-6.776-5.271-11.294-5.271c-3.765,0-7.529,1.506-10.541,4.518     s-4.518,6.776-4.518,10.541c0,4.518,1.506,7.529,3.765,10.541C368.941,389.271,372.706,390.776,376.471,390.776z      M372.706,370.447c0.753-1.506,2.259-2.259,3.765-2.259s3.012,0.753,3.765,2.259c0.753,1.506,1.506,3.012,1.506,4.518     c0,2.259-0.753,3.765-1.506,4.518c-0.753,1.506-2.259,2.259-3.765,2.259s-3.012-0.753-3.765-2.259     c-0.753-1.506-1.506-3.012-1.506-4.518C371.2,373.459,371.953,371.953,372.706,370.447z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.118,361.412 364.424,429.176 377.224,429.176 426.165,361.412    ",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.871,399.059c-3.765,0-7.529,1.506-10.541,4.518s-4.518,6.776-4.518,10.541c0,4.518,1.506,7.529,3.765,10.541     c3.012,3.012,6.023,4.518,10.541,4.518c3.765,0,7.529-1.506,10.541-4.518s4.518-6.776,4.518-10.541     c0-4.518-1.506-7.529-3.765-10.541C422.4,400.565,419.388,399.059,414.871,399.059z M419.388,419.388     c-0.753,1.506-2.259,2.259-3.765,2.259c-1.506,0-3.012-0.753-3.765-2.259c-0.753-1.506-1.506-3.012-1.506-4.518     c0-2.259,0.753-3.765,1.506-4.518c0.753-1.506,2.259-2.259,3.765-2.259c1.506,0,3.012,0.753,3.765,2.259     c0.753,1.506,1.506,3.012,1.506,4.518S420.141,418.635,419.388,419.388z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#ffffff",
    fill: "#ffffff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.b69918321d29add68de3488eda473116.svg";
export { ForwardRef as ReactComponent };